class PitchPrintOption extends BaseOption {
    constructor(container) {
        super(container);

        if (!container.length) return;
        this.pcAjaxObject = pc_ajax_object;
        this.configurator = container.closest('.pc-configurator');
        this.hash = this.configurator.data('hash');
        window.ppClientInstance = null;
        this.pitchPrintWarning = container.find('.pc-pitch-print-warning-popup');

        this.initPitchPrintOption(this.configurator);
        
        this.initPDFButton();
        this.initSlider();
        this.checkElementsCount();

        window.addEventListener('resize', () => {
            this.checkElementsCount();
        });
    }

    checkElementsCount() {
        const totalSlides = this.container.find('.swiper-slide').length;
        if (window.innerWidth > 990 && totalSlides <= 4) {
            this.container.addClass('pc-option-not-enough-slides');
        }else if(window.innerWidth < 990 && window.innerWidth > 768 && totalSlides <= 4){
            this.container.addClass('pc-option-not-enough-slides');
        }else if(window.innerWidth < 768 && window.innerWidth > 580 && totalSlides <= 3){
            this.container.addClass('pc-option-not-enough-slides');
        }else if(window.innerWidth <= 580 && totalSlides < 2){
            this.container.addClass('pc-option-not-enough-slides');
        }else{
            this.container.removeClass('pc-option-not-enough-slides');
        }
    }

    getPPDimensions(){
        return {
            width: 100,
            height: 100,
        }
    }

    bindEvents() {
        super.bindEvents();
    }

    onValueSelect(value, index) {
        if(this.checkPitchPrintNeedWarning()){
            this.pendingValue = value;
            this.pendingIndex = index;

            const continueBtn = this.pitchPrintWarning.find('.pc-warning-continue');
            const cancelBtn = this.pitchPrintWarning.find('.pc-warning-cancel');

            const self = this;
            continueBtn.one('click', function() {
                self.pitchPrintWarning.removeClass('active');
                
                self.values.removeClass('active');
                self.pendingValue.addClass('active');
                
                BaseOption.prototype.onValueSelect.call(self, self.pendingValue, self.pendingIndex);
                
                self.setupBtnDesigAttribute();
                $(document).trigger('option-changed', [self.pendingValue.data('value')]);
                self.clearPendingSelection();
            });

            cancelBtn.one('click', function() {
                self.pitchPrintWarning.removeClass('active');
                self.clearPendingSelection();
            });
        } else {
            super.onValueSelect(value, index);
            this.setupBtnDesigAttribute();
            $(document).trigger('option-changed', [value.data('value')]);
        }
    }

    checkPitchPrintNeedWarning(){
        if(this.btn.attr('data-pp-state') === 'edit'){
            this.pitchPrintWarning.addClass('active');
            return true;
        }

        return false;
    }

    initPitchPrintOption(configurator) {
        this.configurator = configurator;
        this.btn = this.configurator.find('.pc-customize-button');
        this.setupBtnDesigAttribute();
        this.initPitchPrintClient();
        this.onPitchPrint();
    }

    initPitchPrintClient(mode = 'new') {
        if(this.btn.attr('disabled')){
            return;
        }

        const ppApiKey = atob(atob(this.pcAjaxObject.pitchprint_api_key));
        const ppDesignId = this.btn.attr('data-pp-design-id');

        if(!ppApiKey){
            $('.pc-preloader').fadeOut(300);
            return;
        }

        if (!ppDesignId) {
            $('.pc-preloader').fadeOut(300);
            return;
        }

        this.btn.attr('disabled', true);

        let ppArgs = {
            apiKey: ppApiKey,
            designId: ppDesignId,
            custom: true,
            saveForLater: true,
            mode: mode,
            // smartSizes: { width: 148, height: 148 }
        }

        if(mode === 'edit'){
            var projectId = this.btn.attr('data-project-id');
            if(!projectId){
                $('.pc-preloader').fadeOut(300);
            } else {
                ppArgs.projectId = projectId;
            }
        }

        window.ppClientInstance = null;
        window.ppClientInstance = new PitchPrintClient(ppArgs);

        let size_attribute = this.configurator.find('.pc-option-size .pc-option-size__value.active');

        if(size_attribute.length > 0){
            console.log('window.ppClientInstance', window.ppClientInstance.globals);
            try {
                window.ppClientInstance.fire('update-app-globals', { smartSizes: { width: size_attribute.attr('data-width'), height: size_attribute.attr('data-height') }});
            } catch (error) {
                console.error('Ошибка при обновлении глобальных параметров PitchPrint:', error);
            }
        }

        window.ppClientInstance.on('app-validated', () => this.appValidated());
        window.ppClientInstance.on('project-saved', (_val) => this.projectSaved(_val));
        window.ppClientInstance.on('editor-shown', () => {
            $('.pc-preloader').fadeOut(300);
        });

    }

    appValidated(){
        this.btn.attr('disabled', false);
    }

    onPitchPrint() {
        const self = this;
        this.btn.on('click', function () {

            if(self.btn.attr('data-pp-design-id') == null || self.btn.attr('data-pp-design-id').length == 0){
                return;
            }

            $('.pc-preloader').css('display', 'flex').fadeIn(300);

            if(self.btn.attr('data-pp-state') === 'new') {   
                self.initPitchPrintClient('new');
                window.ppClientInstance.fire('show-app');
            } else {
                self.initPitchPrintClient('edit');
                window.ppClientInstance.fire('show-app');
            }
        });
    }

    projectSaved(_val) {
        const _data = _val.data;

        this.clearPitchPrintData();
        this.updateBtnPPState(_data, 'edit');
        this.updateImgPreview(_data);
        this.updatePitchPrintQty(_data);
        this.updateConfiguratorSize(_data);
        this.updatePitchPrintData(_data);
    }

    triggerPriceRecalculation() {
        const configuratorId = this.configurator.data('configurator-id');
        if(configuratorId){
            const priceCalculator = new PriceCalculator();
            priceCalculator.calculate(configuratorId);
        }
    }

    updateConfiguratorSize(_data){
        if(_data.source.pages && _data.source.pages[0].pageData.fWidth && _data.source.pages[0].pageData.fHeight){
            const width = _data.source.pages[0].pageData.fWidth;
            const height = _data.source.pages[0].pageData.fHeight;

            const $sizeOption = this.configurator.find('.pc-option-size');
            if($sizeOption.length > 0){
                const $sizeValue = $sizeOption.find('.pc-option-size__value[data-size="'+width+'x'+height+'"]');
                
                if($sizeValue.length > 0){
                    const sizeOptionInstance = $sizeOption.data('option');
                    if(sizeOptionInstance && sizeOptionInstance instanceof SizeOption){
                        sizeOptionInstance.onValueSelect($sizeValue, $sizeValue.data('index'));
                        
                        this.triggerPriceRecalculation();
                    } else {
                        $sizeValue.trigger('click');
                    }
                }
            }
        }
    }

    clearPitchPrintData() {
        const $dataContainer = this.configurator.find('#pp_data_container');
        $dataContainer.attr({
            'data-project-id': '',
            'data-main-preview': '',
            'data-pdf-url': '',
            'data-previews': ''
        });
    }

    updatePitchPrintData(_data) {
        if (!_data || !_data.projectId) return;

        const $dataContainer = this.configurator.find('#pp_data_container');
        const pdfUrl = this.pcAjaxObject.pitchprint_pdf_base_url + _data.projectId;
        
        const pitchPrintData = {
            projectId: _data.projectId,
            mainPreview: _data.previews && _data.previews.length ? _data.previews[0] : '',
            pdfUrl: pdfUrl,
            previews: _data.previews ? JSON.stringify(_data.previews) : ''
        };

        let attr = {
            'data-project-id': pitchPrintData.projectId,
            'data-main-preview': pitchPrintData.mainPreview,
            'data-pdf-url': pitchPrintData.pdfUrl,
            'data-previews': pitchPrintData.previews,
        }

        if(_data.variation && _data.variation.length > 0){
            this.updatePitchPrintQty(_data);
            pitchPrintData.qty = _data.variation.length;
            attr['data-qty'] = pitchPrintData.qty;
        }

        $dataContainer.attr(attr);

        this.pitchPrintData = pitchPrintData;
    }

    updatePitchPrintQty(_data){
        if(_data.variation && _data.variation.length){
            $(this.configurator).find('.pc-quantity-input').val(_data.variation.length);
            this.triggerPriceRecalculation();
        }
    }

    handlePDFButton(_data) {
        const $pdfBtn = this.configurator.find('.pc-pdf-download-button');
        
        if (_data && _data.projectId) {
            const pdfUrl = this.pcAjaxObject.pitchprint_pdf_base_url + _data.projectId;
            $pdfBtn.attr('href', pdfUrl).show();
        } else {
            $pdfBtn.hide().attr('href', '#');
        }
    }

    updateBtnPPState(_data, mode = 'new') {
        if(mode == 'edit') {
            this.btn.attr({
                'data-project-id': _data.projectId,
                'data-pp-state': 'edit'
            }).text(this.pcAjaxObject.pitchprint_edit_label);
        } else {
            this.btn.attr({
                'data-pp-state': 'new',
                'data-project-id': null
            }).text(this.pcAjaxObject.pitchprint_customize_label);
            this.clearImgPreview();
            // this.handlePDFButton(null);
        }
    }

    clearImgPreview(){
        let _previewDiv = this.configurator.find('#pp_preview_div');
        _previewDiv.empty();
    }

    updateImgPreview(_data){
        let _previewDiv = this.configurator.find('#pp_preview_div');

        if (_data && _data.previews && _data.previews.length) {
            _previewDiv.empty();
            
            const timestamp = new Date().getTime();
            const previewUrl = _data.previews[0] + '?t=' + timestamp;
            
            const $newImg = $('<img>', {
                src: previewUrl,
                alt: 'PitchPrint Preview'
            });
            
            const $loader = $('<div>', {
                class: 'pp-loading-spinner'
            });
            _previewDiv.append($loader);
            
            $newImg.on('load', function() {
                _previewDiv.empty();
                _previewDiv.append($newImg);
            });
            
            $newImg.on('error', function() {
                _previewDiv.empty();
                _previewDiv.append('<div class="pp-error">Error loading preview</div>');
            });
        }
    }

    setupBtnDesigAttribute() {
        let activeDesign = this.getActiveDesign();
        if (!activeDesign) return; 

        this.btn.attr('data-pp-design-id', activeDesign);

        if(!this.hash || this.hash == '' || this.hash == null || this.hash == undefined){
            this.updateBtnPPState(null, 'new');
            this.clearPitchPrintData();
        }
    }

    getActiveDesign() {
        const activeDesign = this.container.find('.pc-option-pitch_print__value.active').attr('data-option-pp-designs');
        return activeDesign;
    }

    initPDFButton() {
        this.configurator.find('.pc-pdf-download-button').on('click', (e) => {
            e.preventDefault();
            const $btn = $(e.currentTarget);
            const href = $btn.attr('href');
            
            if(href === '#') return;
            window.open(href, '_blank');
        });
    }

    clearPendingSelection() {
        this.pendingValue = null;
        this.pendingIndex = null;
    }

    initSlider() {
        const initializeSlider = () => {
            const slider = this.container.find('.pc-option-pitch_print__content');
            
            // Проверяем существование элемента слайдера
            if (!slider.length) return;

            const prevArrow = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 19L8 12L15 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`;

            // Уничтожаем существующий экземпляр слайдера перед созданием нового
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }

            try {
                this.swiper = new Swiper(slider[0], {
                    slidesPerView: 4,
                    spaceBetween: 16,
                    loop: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1.3,
                            spaceBetween: 10,
                            navigation: false
                        },
                        580: {
                            slidesPerView: 2.3,
                            spaceBetween: 12,
                            navigation: false
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 14
                        },
                        990: {
                            slidesPerView: 4,
                            spaceBetween: 16
                        }
                    }
                });

                slider.find('.swiper-button-prev').html(prevArrow);
                slider.find('.swiper-button-next').html(prevArrow);
            } catch (error) {
                console.error('Error initializing Swiper:', error);
            }
        }

        initializeSlider();
        const debouncedInitialize = this.debounce(initializeSlider, 250);
        window.addEventListener('resize', debouncedInitialize);
    }

    // Добавляем вспомогательный метод для debounce
    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
} 